import { Ajax } from '@/common'
const moments = {
  state: {
    pendingCount: 0,
    pendingVideoCount: 0,
    pendingCountStudent: 0,
    pendingVideoCountStudent: 0,
    curClassName: '',
    curStudentName: '',
    curStudent: {
      title: '',
      avatar: '',
      firstName: '',
      lastName: '',
      subTitle1: '',
      status: ''
    }
  },

  mutations: {
    SET_PENDINGCOUNT: (state, count) => {
      state.pendingCount = count
    },
    SET_PENDINGVIDEOCOUNT: (state, count) => {
      state.pendingVideoCount = count
    },
    SET_PENDINGCOUNTSTUDENT: (state, count) => {
      state.pendingCountStudent = count
    },
    SET_PENDINGVIDEOCOUNTSTUDENT: (state, count) => {
      state.pendingVideoCountStudent = count
    },
    SET_CURCLASSNAME: (state, name) => {
      state.curClassName = name
    },
    SET_CURSTUDENTNAME: (state, name) => {
      state.curStudentName = name
    },
    SET_CURSTUDENT: (state, obj) => {
      state.curStudent = obj
    }
  },

  actions: {
    // 登录
    fetchPendingData({ commit }, obj) {
      return new Promise((resolve, reject) => {
        Promise.all([
          Ajax.post('/moments/media/getMediaCountV1', {
            classId: obj.classId,
            status: 1,
            mediaType: 0
            // date: obj.date.format('YYYY-MM')
          }),
          Ajax.post('/moments/media/getMediaCountV1', {
            classId: obj.classId,
            status: 1,
            mediaType: 1
            // date: obj.date.format('YYYY-MM')
          })
        ])
          .then(([photoRes, videoRes]) => {
            if (photoRes.code == '0000') {
              commit('SET_PENDINGCOUNT', photoRes.data > 9999 ? 9999 : photoRes.data)
            }
            if (videoRes.code == '0000') {
              commit('SET_PENDINGVIDEOCOUNT', videoRes.data > 9999 ? 9999 : videoRes.data)
            }
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    fetchPendingDataStudent({ commit }, obj) {
      return new Promise((resolve, reject) => {
        Promise.all([
          Ajax.post('/moments/media/getMediaCountV1', {
            studentId: obj.studentId,
            classId: obj.classId,
            status: 1,
            mediaType: 0
            // date: obj.date.format('YYYY-MM')
          }),
          Ajax.post('/moments/media/getMediaCountV1', {
            studentId: obj.studentId,
            classId: obj.classId,
            status: 1,
            mediaType: 1
            // date: obj.date.format('YYYY-MM')
          })
        ])
          .then(([photoRes, videoRes]) => {
            if (photoRes.code == '0000') {
              commit('SET_PENDINGCOUNTSTUDENT', photoRes.data > 9999 ? 9999 : photoRes.data)
            }
            if (videoRes.code == '0000') {
              commit('SET_PENDINGVIDEOCOUNTSTUDENT', videoRes.data > 9999 ? 9999 : videoRes.data)
            }
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default moments
